module.exports = __webpack_public_path__ + "img/gift_box_bg_1.7adaf6cc.jpg";